<template>
  <div>
    <ak-model-filter-card
      model="userSearch"
      @search="search"
      @reset="reset"
    />
    <a-spin :spinning="false" class="p-x-8">
      <div class="relative">
        <ak-model-tree
          class="m-t-20"
          ref="treeNode"
          model="users"
          treeModel="hierarchy"
          pointerToTree="hierarchy"
          :multiple="false"
          :treeSpan="5"
          parentKey="parent"
          rootName="用户层级"
          :modelTableProps="{ filters }"
        />
        <!-- selection: true  -->
        <TextButton
          v-if="isAdmin"
          text="添加"
          class="absolute -translate-x-full"
          style="left:18.5%; top: 35px"
          @click="addRootLevel"
        />
      </div>
    </a-spin>
    <a-modal
    :maskClosable="false"
      title="添加层级"
      :visible="visibleAddRoot"
      destroyOnClose
      :confirm-loading="confirmAddRootLoading"
      @ok="handleOk"
      @cancel="visibleAddRoot = false"
    >
      <ak-type-input
        ref="addLevel"
        v-model="rootLevelName"
        label="层级名称"
        type="String"
        :validators="validators"
      />
    </a-modal>
  </div>
</template>
<script>
import TextButton from '../../components/textButton'
import { notEmpty } from '../../utils/validator'
import { createLevelTag } from '../../utils/level'
import { mapGetters } from 'vuex'
export default {
  components: {
    TextButton
  },
  data () {
    return {
      visibleAddRoot: false,
      confirmAddRootLoading: false,
      rootLevelName: '',
      validators: [notEmpty()],
      filters: {}
    }
  },
  computed: {
    ...mapGetters(['isAdmin'])
  },
  mounted () {},
  methods: {
    addRootLevel () {
      this.rootLevelName = ''
      this.confirmAddRootLoading = false
      this.visibleAddRoot = true
    },
    async handleOk () {
      const error = await this.$refs.addLevel.validate()
      if (error) {
        return
      }

      this.$loading.show()
      try {
        const res = await this.$tkParse.get('/classes/hierarchy', {
          params: {
            where: {
              level: 1
            },
            order: '-createdAt',
            limit: 1
          }
        })
        let tag
        if (res.data.results.length === 0) {
          tag = '1-'
        } else {
          tag = createLevelTag(res.data.results[0].tag)
        }
        const data = {
          name: this.rootLevelName,
          level: 1,
          tag: tag
        }
        await this.$tkParse.post('/classes/hierarchy', data)
        this.$refs.treeNode.refresh()
        this.visibleAddRoot = false
      } catch (e) {
        console.log(e)
        this.$notification['error']({
          message: '操作失败',
          description: '操作失败，请重试'
        })
      }
      this.$loading.hide()
    },
    search (filters) {
      this.filters = filters
    },
    reset () {
      this.filters = {}
    }
  }
}
</script>
<style lang="scss" scoped>
.amdin_role_card {
  height: 152px;
  color: #152137;
}
::v-deep {
  .node-button {
    margin-right: 4px !important;
    &:hover {
      color: #2fbf79 !important;
    }
  }
  .tree-title.selected {
    color: #2fbf79 !important;
  }
}
</style>
